import React from 'react'
import { countStatusesExceptReserved } from '../CourseHelperFunctions';
import { bookingStatusOptions } from '../shared/translations';
import BookingStatusDropdown from './booking-status-dropdown';
import { useTranslation } from 'react-i18next';
import { BOOKINGS_LIST_NEW_PARTICIPANT } from '../../../i18n/keyConstants';
import Checkbox from '../../Checkbox';

const BookingListItem = ({ borderBottom, name, children, handleDelete, coaEmpId, marked, markedChanged }) => {
    return (
        <div
            style={{
                padding: "16px 0px",
                display: "flex",
                alignItems: "center",
                borderBottom: borderBottom ? "1px solid lightgrey" : "none"
            }}
            key={coaEmpId}>

            <Checkbox style={{ flex: "0 0 15%" }}
                setValue={markedChanged}
                value={marked}
            />
            <div style={{ flex: "0 0 40%" }}>
                {name}
            </div>
            <div style={{ flex: "0 0 30%" }}>
                {children}
            </div>
            <div style={{ flex: "0 0 15%", textAlign: "right" }}>
                <button
                    onClick={handleDelete}
                    className='oi oi-trash text-secondary'
                    style={{
                        background: "inherit",
                        border: "none",
                        padding: 0,
                        cursor: "pointer",
                        outline: "inherit",
                    }}
                />
            </div>
        </div>
    );
}

export default function BookingsList({
    newBookings,
    deleteNewBooking,
    filteredExistingBookings,
    deleteExistingBooking,
    updateBookingStatus,
    updateBookingMark,
    course
}) {
    const { t } = useTranslation(['bookingsList']);
    return (
        <div style={{
            margin: "26px 0px",
            maxHeight: "260px",
            minHeight: "260px",
            overflowY: "scroll"
        }}>
            {newBookings.map((newBooking, index) => (
                <BookingListItem
                    key={index}
                    name={newBooking.name}
                    markedChanged={(opt) => updateBookingMark(newBooking, opt)}
                    coaEmpId={newBooking.coaEmpId}
                    marked={newBooking.marked}
                    handleDelete={() => deleteNewBooking(newBooking.coaEmpId)}
                    borderBottom={(filteredExistingBookings.length > 0) &&
                        ((newBooking.length - 1) !== index)
                    }
                >
                    <span style={{ padding: "8px" }}>{t(BOOKINGS_LIST_NEW_PARTICIPANT)}</span>
                </BookingListItem>
            ))}

            {filteredExistingBookings.map((existingBooking, index) => (
                <BookingListItem
                    key={index}
                    name={existingBooking.coaEmpName}
                    coaEmpId={existingBooking.coaEmpId}
                    marked={existingBooking.marked}
                    markedChanged={(val) => updateBookingMark(existingBooking, val)}
                    handleDelete={() => deleteExistingBooking(existingBooking.coaEmpId)}
                    borderBottom={(filteredExistingBookings.length - 1) !== index}
                >
                    <BookingStatusDropdown
                        onChange={(option) => updateBookingStatus(existingBooking, option.value)}
                        value={existingBooking.status}
                        maxNumberOfBookings={course.maxNumBookings}
                        numberOfConfirmedBookings={
                            countStatusesExceptReserved(
                                filteredExistingBookings,
                                bookingStatusOptions.Reserve.value
                            )
                        }
                    />
                </BookingListItem>
            ))}
        </div>
    )
}
